"use strict";
/* tslint:disable */
Object.defineProperty(exports, "__esModule", { value: true });
var reverb_search_CSPSearchRequest_Aggregation;
(function (reverb_search_CSPSearchRequest_Aggregation) {
    reverb_search_CSPSearchRequest_Aggregation["BRAND_NAMES"] = "BRAND_NAMES";
    reverb_search_CSPSearchRequest_Aggregation["FINISHES"] = "FINISHES";
    reverb_search_CSPSearchRequest_Aggregation["CATEGORY_UUIDS"] = "CATEGORY_UUIDS";
    reverb_search_CSPSearchRequest_Aggregation["DECADES"] = "DECADES";
})(reverb_search_CSPSearchRequest_Aggregation = exports.reverb_search_CSPSearchRequest_Aggregation || (exports.reverb_search_CSPSearchRequest_Aggregation = {}));
var reverb_search_FullTextQueryOperand;
(function (reverb_search_FullTextQueryOperand) {
    reverb_search_FullTextQueryOperand["OR"] = "OR";
    reverb_search_FullTextQueryOperand["AND"] = "AND";
})(reverb_search_FullTextQueryOperand = exports.reverb_search_FullTextQueryOperand || (exports.reverb_search_FullTextQueryOperand = {}));
var reverb_search_CSPSearchRequest_Sort;
(function (reverb_search_CSPSearchRequest_Sort) {
    reverb_search_CSPSearchRequest_Sort["NONE"] = "NONE";
    reverb_search_CSPSearchRequest_Sort["QUALITY_DESC"] = "QUALITY_DESC";
    reverb_search_CSPSearchRequest_Sort["LISTING_COUNT_DESC"] = "LISTING_COUNT_DESC";
    reverb_search_CSPSearchRequest_Sort["TITLE_RAW_ASC"] = "TITLE_RAW_ASC";
    reverb_search_CSPSearchRequest_Sort["CREATED_AT_ASC"] = "CREATED_AT_ASC";
    reverb_search_CSPSearchRequest_Sort["RECENT_ORDERS_COUNT_DESC"] = "RECENT_ORDERS_COUNT_DESC";
    reverb_search_CSPSearchRequest_Sort["TRENDING_DESC"] = "TRENDING_DESC";
    reverb_search_CSPSearchRequest_Sort["RECENT_ORDERS_COUNT_ASC"] = "RECENT_ORDERS_COUNT_ASC";
    reverb_search_CSPSearchRequest_Sort["RECENT_ORDERS_COUNT_USED_DESC"] = "RECENT_ORDERS_COUNT_USED_DESC";
    reverb_search_CSPSearchRequest_Sort["RECENT_ORDERS_COUNT_NEW_DESC"] = "RECENT_ORDERS_COUNT_NEW_DESC";
    reverb_search_CSPSearchRequest_Sort["RECENT_ORDERS_COUNT_USED_ASC"] = "RECENT_ORDERS_COUNT_USED_ASC";
    reverb_search_CSPSearchRequest_Sort["RECENT_ORDERS_COUNT_NEW_ASC"] = "RECENT_ORDERS_COUNT_NEW_ASC";
    reverb_search_CSPSearchRequest_Sort["LISTING_MIN_PRICE_USED_DESC"] = "LISTING_MIN_PRICE_USED_DESC";
    reverb_search_CSPSearchRequest_Sort["LISTING_MIN_PRICE_NEW_DESC"] = "LISTING_MIN_PRICE_NEW_DESC";
    reverb_search_CSPSearchRequest_Sort["LISTING_MIN_PRICE_USED_ASC"] = "LISTING_MIN_PRICE_USED_ASC";
    reverb_search_CSPSearchRequest_Sort["LISTING_MIN_PRICE_NEW_ASC"] = "LISTING_MIN_PRICE_NEW_ASC";
    reverb_search_CSPSearchRequest_Sort["AVERAGE_ORDER_PRICE_USED_ASC"] = "AVERAGE_ORDER_PRICE_USED_ASC";
    reverb_search_CSPSearchRequest_Sort["AVERAGE_ORDER_PRICE_USED_DESC"] = "AVERAGE_ORDER_PRICE_USED_DESC";
    reverb_search_CSPSearchRequest_Sort["AVERAGE_ORDER_PRICE_NEW_ASC"] = "AVERAGE_ORDER_PRICE_NEW_ASC";
    reverb_search_CSPSearchRequest_Sort["AVERAGE_ORDER_PRICE_NEW_DESC"] = "AVERAGE_ORDER_PRICE_NEW_DESC";
    reverb_search_CSPSearchRequest_Sort["AVERAGE_ORDER_PRICE_ASC"] = "AVERAGE_ORDER_PRICE_ASC";
    reverb_search_CSPSearchRequest_Sort["AVERAGE_ORDER_PRICE_DESC"] = "AVERAGE_ORDER_PRICE_DESC";
    reverb_search_CSPSearchRequest_Sort["LIVE_LISTINGS_USED_ASC"] = "LIVE_LISTINGS_USED_ASC";
    reverb_search_CSPSearchRequest_Sort["LIVE_LISTINGS_NEW_ASC"] = "LIVE_LISTINGS_NEW_ASC";
    reverb_search_CSPSearchRequest_Sort["LIVE_LISTINGS_USED_DESC"] = "LIVE_LISTINGS_USED_DESC";
    reverb_search_CSPSearchRequest_Sort["LIVE_LISTINGS_NEW_DESC"] = "LIVE_LISTINGS_NEW_DESC";
    reverb_search_CSPSearchRequest_Sort["LIVE_LISTINGS_ASC"] = "LIVE_LISTINGS_ASC";
    reverb_search_CSPSearchRequest_Sort["LIVE_LISTINGS_DESC"] = "LIVE_LISTINGS_DESC";
    reverb_search_CSPSearchRequest_Sort["IMPRESSIONS_ASC"] = "IMPRESSIONS_ASC";
    reverb_search_CSPSearchRequest_Sort["IMPRESSIONS_DESC"] = "IMPRESSIONS_DESC";
})(reverb_search_CSPSearchRequest_Sort = exports.reverb_search_CSPSearchRequest_Sort || (exports.reverb_search_CSPSearchRequest_Sort = {}));
var core_apimessages_NamedImageTransforms;
(function (core_apimessages_NamedImageTransforms) {
    core_apimessages_NamedImageTransforms["THUMB"] = "THUMB";
    core_apimessages_NamedImageTransforms["CARD_SQUARE"] = "CARD_SQUARE";
    core_apimessages_NamedImageTransforms["CARD_WIDE"] = "CARD_WIDE";
    core_apimessages_NamedImageTransforms["LARGE"] = "LARGE";
    core_apimessages_NamedImageTransforms["SUPERSIZE"] = "SUPERSIZE";
    core_apimessages_NamedImageTransforms["BANNER_WIDE"] = "BANNER_WIDE";
    core_apimessages_NamedImageTransforms["BANNER_4_1"] = "BANNER_4_1";
    core_apimessages_NamedImageTransforms["SHOP_BANNER"] = "SHOP_BANNER";
})(core_apimessages_NamedImageTransforms = exports.core_apimessages_NamedImageTransforms || (exports.core_apimessages_NamedImageTransforms = {}));
var core_apimessages_Image_FallbackType;
(function (core_apimessages_Image_FallbackType) {
    core_apimessages_Image_FallbackType["NONE"] = "NONE";
    core_apimessages_Image_FallbackType["LP_CANONICAL"] = "LP_CANONICAL";
})(core_apimessages_Image_FallbackType = exports.core_apimessages_Image_FallbackType || (exports.core_apimessages_Image_FallbackType = {}));
var reverb_search_ListingsSearchRequest_Sort;
(function (reverb_search_ListingsSearchRequest_Sort) {
    reverb_search_ListingsSearchRequest_Sort["NONE"] = "NONE";
    reverb_search_ListingsSearchRequest_Sort["PUBLISHED_AT_ASC"] = "PUBLISHED_AT_ASC";
    reverb_search_ListingsSearchRequest_Sort["PUBLISHED_AT_DESC"] = "PUBLISHED_AT_DESC";
    reverb_search_ListingsSearchRequest_Sort["PRICE_ASC"] = "PRICE_ASC";
    reverb_search_ListingsSearchRequest_Sort["PRICE_DESC"] = "PRICE_DESC";
    reverb_search_ListingsSearchRequest_Sort["BUMPED_FIRST"] = "BUMPED_FIRST";
    reverb_search_ListingsSearchRequest_Sort["CURATED"] = "CURATED";
    reverb_search_ListingsSearchRequest_Sort["CURATED_DATE_ADDED"] = "CURATED_DATE_ADDED";
    reverb_search_ListingsSearchRequest_Sort["LQS_DESCENDING"] = "LQS_DESCENDING";
    reverb_search_ListingsSearchRequest_Sort["RANDOM"] = "RANDOM";
    reverb_search_ListingsSearchRequest_Sort["WATCHERS_COUNT_ASC"] = "WATCHERS_COUNT_ASC";
    reverb_search_ListingsSearchRequest_Sort["WATCHERS_COUNT_DESC"] = "WATCHERS_COUNT_DESC";
    reverb_search_ListingsSearchRequest_Sort["FILTERED_IDS"] = "FILTERED_IDS";
    reverb_search_ListingsSearchRequest_Sort["PRICING_SCORE"] = "PRICING_SCORE";
    reverb_search_ListingsSearchRequest_Sort["PRICE_IN_COUNTRY"] = "PRICE_IN_COUNTRY";
    reverb_search_ListingsSearchRequest_Sort["BUMP_SCORE"] = "BUMP_SCORE";
})(reverb_search_ListingsSearchRequest_Sort = exports.reverb_search_ListingsSearchRequest_Sort || (exports.reverb_search_ListingsSearchRequest_Sort = {}));
var reverb_search_ListingsSearchRequest_Aggregation;
(function (reverb_search_ListingsSearchRequest_Aggregation) {
    reverb_search_ListingsSearchRequest_Aggregation["CATEGORY_UUIDS"] = "CATEGORY_UUIDS";
    reverb_search_ListingsSearchRequest_Aggregation["BRAND_UUIDS"] = "BRAND_UUIDS";
    reverb_search_ListingsSearchRequest_Aggregation["BRAND_SLUGS"] = "BRAND_SLUGS";
    reverb_search_ListingsSearchRequest_Aggregation["CATEGORY_SLUGS"] = "CATEGORY_SLUGS";
    reverb_search_ListingsSearchRequest_Aggregation["CONDITION_SLUGS"] = "CONDITION_SLUGS";
    reverb_search_ListingsSearchRequest_Aggregation["DECADES"] = "DECADES";
    reverb_search_ListingsSearchRequest_Aggregation["CURATED_SETS"] = "CURATED_SETS";
    reverb_search_ListingsSearchRequest_Aggregation["TRAITS"] = "TRAITS";
    reverb_search_ListingsSearchRequest_Aggregation["CANONICAL_FINISH"] = "CANONICAL_FINISH";
})(reverb_search_ListingsSearchRequest_Aggregation = exports.reverb_search_ListingsSearchRequest_Aggregation || (exports.reverb_search_ListingsSearchRequest_Aggregation = {}));
var reverb_reporting_Condition;
(function (reverb_reporting_Condition) {
    reverb_reporting_Condition["ALL"] = "ALL";
    reverb_reporting_Condition["NEW"] = "NEW";
    reverb_reporting_Condition["USED"] = "USED";
})(reverb_reporting_Condition = exports.reverb_reporting_Condition || (exports.reverb_reporting_Condition = {}));
var reverb_reporting_CSPStatsMetric;
(function (reverb_reporting_CSPStatsMetric) {
    reverb_reporting_CSPStatsMetric["TOTAL_ORDER_VALUE_USC"] = "TOTAL_ORDER_VALUE_USC";
    reverb_reporting_CSPStatsMetric["ORDER_QUANTITY"] = "ORDER_QUANTITY";
    reverb_reporting_CSPStatsMetric["AVG_ORDER_PRICE_USC"] = "AVG_ORDER_PRICE_USC";
    reverb_reporting_CSPStatsMetric["LIVE_LISTING_COUNT"] = "LIVE_LISTING_COUNT";
    reverb_reporting_CSPStatsMetric["MIN_LISTING_PRICE_USC"] = "MIN_LISTING_PRICE_USC";
})(reverb_reporting_CSPStatsMetric = exports.reverb_reporting_CSPStatsMetric || (exports.reverb_reporting_CSPStatsMetric = {}));
var core_apimessages_ProductSpec_Type;
(function (core_apimessages_ProductSpec_Type) {
    core_apimessages_ProductSpec_Type["BRAND"] = "BRAND";
    core_apimessages_ProductSpec_Type["MODEL"] = "MODEL";
    core_apimessages_ProductSpec_Type["FINISH"] = "FINISH";
    core_apimessages_ProductSpec_Type["YEAR"] = "YEAR";
    core_apimessages_ProductSpec_Type["COUNTRY_OF_ORIGIN"] = "COUNTRY_OF_ORIGIN";
    core_apimessages_ProductSpec_Type["CATEGORY"] = "CATEGORY";
    core_apimessages_ProductSpec_Type["TRAIT"] = "TRAIT";
    core_apimessages_ProductSpec_Type["CONDITION"] = "CONDITION";
})(core_apimessages_ProductSpec_Type = exports.core_apimessages_ProductSpec_Type || (exports.core_apimessages_ProductSpec_Type = {}));
var core_apimessages_Listing_ListingType;
(function (core_apimessages_Listing_ListingType) {
    core_apimessages_Listing_ListingType["AUCTION"] = "AUCTION";
    core_apimessages_Listing_ListingType["MAKE_AN_OFFER"] = "MAKE_AN_OFFER";
    core_apimessages_Listing_ListingType["BUY_IT_NOW"] = "BUY_IT_NOW";
    core_apimessages_Listing_ListingType["DIGITAL"] = "DIGITAL";
    core_apimessages_Listing_ListingType["CORE_AUCTION"] = "CORE_AUCTION";
})(core_apimessages_Listing_ListingType = exports.core_apimessages_Listing_ListingType || (exports.core_apimessages_Listing_ListingType = {}));
var core_apimessages_Listing_SeedType;
(function (core_apimessages_Listing_SeedType) {
    core_apimessages_Listing_SeedType["ComparisonShoppingPage"] = "ComparisonShoppingPage";
    core_apimessages_Listing_SeedType["CanonicalProduct"] = "CanonicalProduct";
    core_apimessages_Listing_SeedType["PriceGuide"] = "PriceGuide";
    core_apimessages_Listing_SeedType["Product"] = "Product";
    core_apimessages_Listing_SeedType["Order"] = "Order";
})(core_apimessages_Listing_SeedType = exports.core_apimessages_Listing_SeedType || (exports.core_apimessages_Listing_SeedType = {}));
var core_apimessages_Sale_SaleState;
(function (core_apimessages_Sale_SaleState) {
    core_apimessages_Sale_SaleState["LIVE"] = "LIVE";
    core_apimessages_Sale_SaleState["ENDED"] = "ENDED";
    core_apimessages_Sale_SaleState["UPCOMING"] = "UPCOMING";
})(core_apimessages_Sale_SaleState = exports.core_apimessages_Sale_SaleState || (exports.core_apimessages_Sale_SaleState = {}));
var core_apimessages_Ribbon_Reason;
(function (core_apimessages_Ribbon_Reason) {
    core_apimessages_Ribbon_Reason["PRICE_DROP"] = "PRICE_DROP";
    core_apimessages_Ribbon_Reason["SALE"] = "SALE";
})(core_apimessages_Ribbon_Reason = exports.core_apimessages_Ribbon_Reason || (exports.core_apimessages_Ribbon_Reason = {}));
var core_apimessages_ShippingMethod;
(function (core_apimessages_ShippingMethod) {
    core_apimessages_ShippingMethod["UNKNOWN"] = "UNKNOWN";
    core_apimessages_ShippingMethod["SHIPPED"] = "SHIPPED";
    core_apimessages_ShippingMethod["LOCAL"] = "LOCAL";
    core_apimessages_ShippingMethod["EXPEDITED_SHIPPING"] = "EXPEDITED_SHIPPING";
    core_apimessages_ShippingMethod["DIGITAL_DELIVERY"] = "DIGITAL_DELIVERY";
})(core_apimessages_ShippingMethod = exports.core_apimessages_ShippingMethod || (exports.core_apimessages_ShippingMethod = {}));
var core_apimessages_Channel;
(function (core_apimessages_Channel) {
    core_apimessages_Channel["REVERB"] = "REVERB";
    core_apimessages_Channel["SELLER_SITE"] = "SELLER_SITE";
    core_apimessages_Channel["LP"] = "LP";
})(core_apimessages_Channel = exports.core_apimessages_Channel || (exports.core_apimessages_Channel = {}));
var core_apimessages_Shop_ShopType;
(function (core_apimessages_Shop_ShopType) {
    core_apimessages_Shop_ShopType["UNKNOWN"] = "UNKNOWN";
    core_apimessages_Shop_ShopType["INDIVIDUAL"] = "INDIVIDUAL";
    core_apimessages_Shop_ShopType["BUSINESS"] = "BUSINESS";
})(core_apimessages_Shop_ShopType = exports.core_apimessages_Shop_ShopType || (exports.core_apimessages_Shop_ShopType = {}));
var core_apimessages_ShippingRates_RegionType;
(function (core_apimessages_ShippingRates_RegionType) {
    core_apimessages_ShippingRates_RegionType["COUNTRY"] = "COUNTRY";
    core_apimessages_ShippingRates_RegionType["SUBREGION"] = "SUBREGION";
    core_apimessages_ShippingRates_RegionType["SUPERREGION"] = "SUPERREGION";
    core_apimessages_ShippingRates_RegionType["EVERYWHERE_ELSE"] = "EVERYWHERE_ELSE";
})(core_apimessages_ShippingRates_RegionType = exports.core_apimessages_ShippingRates_RegionType || (exports.core_apimessages_ShippingRates_RegionType = {}));
var core_apimessages_ShopTaxPolicy_PolicyType;
(function (core_apimessages_ShopTaxPolicy_PolicyType) {
    core_apimessages_ShopTaxPolicy_PolicyType["SELLER"] = "SELLER";
    core_apimessages_ShopTaxPolicy_PolicyType["MARKETPLACE_REGION"] = "MARKETPLACE_REGION";
    core_apimessages_ShopTaxPolicy_PolicyType["AUTO_CALCULATED"] = "AUTO_CALCULATED";
})(core_apimessages_ShopTaxPolicy_PolicyType = exports.core_apimessages_ShopTaxPolicy_PolicyType || (exports.core_apimessages_ShopTaxPolicy_PolicyType = {}));
var core_apimessages_Feedback_Type;
(function (core_apimessages_Feedback_Type) {
    core_apimessages_Feedback_Type["RECEIVED"] = "RECEIVED";
    core_apimessages_Feedback_Type["BUYER"] = "BUYER";
    core_apimessages_Feedback_Type["SELLER"] = "SELLER";
})(core_apimessages_Feedback_Type = exports.core_apimessages_Feedback_Type || (exports.core_apimessages_Feedback_Type = {}));
var reverb_search_LPListingsSearchRequest_Condition;
(function (reverb_search_LPListingsSearchRequest_Condition) {
    reverb_search_LPListingsSearchRequest_Condition["NONE"] = "NONE";
    reverb_search_LPListingsSearchRequest_Condition["NEW"] = "NEW";
    reverb_search_LPListingsSearchRequest_Condition["USED"] = "USED";
})(reverb_search_LPListingsSearchRequest_Condition = exports.reverb_search_LPListingsSearchRequest_Condition || (exports.reverb_search_LPListingsSearchRequest_Condition = {}));
var core_apimessages_MyBidDetails_BidDetailStatus;
(function (core_apimessages_MyBidDetails_BidDetailStatus) {
    core_apimessages_MyBidDetails_BidDetailStatus["NOT_BIDDING"] = "NOT_BIDDING";
    core_apimessages_MyBidDetails_BidDetailStatus["LOST"] = "LOST";
    core_apimessages_MyBidDetails_BidDetailStatus["LOSING"] = "LOSING";
    core_apimessages_MyBidDetails_BidDetailStatus["WINNING"] = "WINNING";
    core_apimessages_MyBidDetails_BidDetailStatus["WON"] = "WON";
})(core_apimessages_MyBidDetails_BidDetailStatus = exports.core_apimessages_MyBidDetails_BidDetailStatus || (exports.core_apimessages_MyBidDetails_BidDetailStatus = {}));
var core_apimessages_Order_Status;
(function (core_apimessages_Order_Status) {
    core_apimessages_Order_Status["UNPAID"] = "UNPAID";
    core_apimessages_Order_Status["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    core_apimessages_Order_Status["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    core_apimessages_Order_Status["PAID"] = "PAID";
    core_apimessages_Order_Status["SHIPPED"] = "SHIPPED";
    core_apimessages_Order_Status["PICKED_UP"] = "PICKED_UP";
    core_apimessages_Order_Status["RECEIVED"] = "RECEIVED";
    core_apimessages_Order_Status["PRESUMED_RECEIVED"] = "PRESUMED_RECEIVED";
    core_apimessages_Order_Status["CANCELLED"] = "CANCELLED";
    core_apimessages_Order_Status["REFUNDED"] = "REFUNDED";
    core_apimessages_Order_Status["LAYAWAY_FORFEITED"] = "LAYAWAY_FORFEITED";
})(core_apimessages_Order_Status = exports.core_apimessages_Order_Status || (exports.core_apimessages_Order_Status = {}));
var core_apimessages_AddressVerificationStatus;
(function (core_apimessages_AddressVerificationStatus) {
    core_apimessages_AddressVerificationStatus["VERIFIED"] = "VERIFIED";
    core_apimessages_AddressVerificationStatus["NOT_VERIFIED"] = "NOT_VERIFIED";
})(core_apimessages_AddressVerificationStatus = exports.core_apimessages_AddressVerificationStatus || (exports.core_apimessages_AddressVerificationStatus = {}));
var core_apimessages_Payment_PaymentMethod;
(function (core_apimessages_Payment_PaymentMethod) {
    core_apimessages_Payment_PaymentMethod["DIRECT_CHECKOUT"] = "DIRECT_CHECKOUT";
    core_apimessages_Payment_PaymentMethod["PAYPAL"] = "PAYPAL";
    core_apimessages_Payment_PaymentMethod["AFFIRM"] = "AFFIRM";
    core_apimessages_Payment_PaymentMethod["OTHER"] = "OTHER";
    core_apimessages_Payment_PaymentMethod["DC_VIA_PAYPAL"] = "DC_VIA_PAYPAL";
    core_apimessages_Payment_PaymentMethod["PAYPAL_MANUAL"] = "PAYPAL_MANUAL";
    core_apimessages_Payment_PaymentMethod["ANDROID_PAY"] = "ANDROID_PAY";
    core_apimessages_Payment_PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    core_apimessages_Payment_PaymentMethod["SOFORT"] = "SOFORT";
    core_apimessages_Payment_PaymentMethod["BANK_WIRE"] = "BANK_WIRE";
    core_apimessages_Payment_PaymentMethod["CASH"] = "CASH";
    core_apimessages_Payment_PaymentMethod["CHECK"] = "CHECK";
    core_apimessages_Payment_PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    core_apimessages_Payment_PaymentMethod["MONEY_ORDER"] = "MONEY_ORDER";
    core_apimessages_Payment_PaymentMethod["ESCROW_COM"] = "ESCROW_COM";
})(core_apimessages_Payment_PaymentMethod = exports.core_apimessages_Payment_PaymentMethod || (exports.core_apimessages_Payment_PaymentMethod = {}));
var core_apimessages_Payment_PaymentStatus;
(function (core_apimessages_Payment_PaymentStatus) {
    core_apimessages_Payment_PaymentStatus["REFUNDED"] = "REFUNDED";
    core_apimessages_Payment_PaymentStatus["COMPLETED"] = "COMPLETED";
    core_apimessages_Payment_PaymentStatus["PENDING"] = "PENDING";
    core_apimessages_Payment_PaymentStatus["FAILED"] = "FAILED";
    core_apimessages_Payment_PaymentStatus["NONE"] = "NONE";
    core_apimessages_Payment_PaymentStatus["CANCELLED"] = "CANCELLED";
})(core_apimessages_Payment_PaymentStatus = exports.core_apimessages_Payment_PaymentStatus || (exports.core_apimessages_Payment_PaymentStatus = {}));
var core_apimessages_OrderRefunds_RefundableState;
(function (core_apimessages_OrderRefunds_RefundableState) {
    core_apimessages_OrderRefunds_RefundableState["REFUNDABLE"] = "REFUNDABLE";
    core_apimessages_OrderRefunds_RefundableState["SELLER_REFUNDABLE"] = "SELLER_REFUNDABLE";
    core_apimessages_OrderRefunds_RefundableState["NON_REFUNDABLE"] = "NON_REFUNDABLE";
})(core_apimessages_OrderRefunds_RefundableState = exports.core_apimessages_OrderRefunds_RefundableState || (exports.core_apimessages_OrderRefunds_RefundableState = {}));
var core_apimessages_RefundRequest_RefundType;
(function (core_apimessages_RefundRequest_RefundType) {
    core_apimessages_RefundRequest_RefundType["FULL"] = "FULL";
    core_apimessages_RefundRequest_RefundType["PARTIAL"] = "PARTIAL";
})(core_apimessages_RefundRequest_RefundType = exports.core_apimessages_RefundRequest_RefundType || (exports.core_apimessages_RefundRequest_RefundType = {}));
var core_apimessages_RefundRequest_RefundState;
(function (core_apimessages_RefundRequest_RefundState) {
    core_apimessages_RefundRequest_RefundState["APPROVED"] = "APPROVED";
    core_apimessages_RefundRequest_RefundState["CONDITIONALLY_APPROVED"] = "CONDITIONALLY_APPROVED";
    core_apimessages_RefundRequest_RefundState["CANCELLED"] = "CANCELLED";
    core_apimessages_RefundRequest_RefundState["DENIED"] = "DENIED";
    core_apimessages_RefundRequest_RefundState["PENDING"] = "PENDING";
    core_apimessages_RefundRequest_RefundState["PENDING_SELLER_RESPONSE"] = "PENDING_SELLER_RESPONSE";
})(core_apimessages_RefundRequest_RefundState = exports.core_apimessages_RefundRequest_RefundState || (exports.core_apimessages_RefundRequest_RefundState = {}));
var core_apimessages_SellerOrder_TaxResponsibleParty;
(function (core_apimessages_SellerOrder_TaxResponsibleParty) {
    core_apimessages_SellerOrder_TaxResponsibleParty["REVERB"] = "REVERB";
    core_apimessages_SellerOrder_TaxResponsibleParty["SELLER"] = "SELLER";
})(core_apimessages_SellerOrder_TaxResponsibleParty = exports.core_apimessages_SellerOrder_TaxResponsibleParty || (exports.core_apimessages_SellerOrder_TaxResponsibleParty = {}));
var reverb_search_SubAggregationsByListingRequest_TargetIndex;
(function (reverb_search_SubAggregationsByListingRequest_TargetIndex) {
    reverb_search_SubAggregationsByListingRequest_TargetIndex["NEGOTIATIONS"] = "NEGOTIATIONS";
})(reverb_search_SubAggregationsByListingRequest_TargetIndex = exports.reverb_search_SubAggregationsByListingRequest_TargetIndex || (exports.reverb_search_SubAggregationsByListingRequest_TargetIndex = {}));
var reverb_search_SubAggregationsByListingRequest_Aggregation;
(function (reverb_search_SubAggregationsByListingRequest_Aggregation) {
    reverb_search_SubAggregationsByListingRequest_Aggregation["LISTING_NEGOTIATION_METRICS"] = "LISTING_NEGOTIATION_METRICS";
})(reverb_search_SubAggregationsByListingRequest_Aggregation = exports.reverb_search_SubAggregationsByListingRequest_Aggregation || (exports.reverb_search_SubAggregationsByListingRequest_Aggregation = {}));
var reverb_search_Filter_WidgetType;
(function (reverb_search_Filter_WidgetType) {
    reverb_search_Filter_WidgetType["CHECKBOX"] = "CHECKBOX";
    reverb_search_Filter_WidgetType["RADIO"] = "RADIO";
    reverb_search_Filter_WidgetType["NESTED_SELECT"] = "NESTED_SELECT";
    reverb_search_Filter_WidgetType["TEXT"] = "TEXT";
    reverb_search_Filter_WidgetType["RANGE"] = "RANGE";
    reverb_search_Filter_WidgetType["NONE"] = "NONE";
    reverb_search_Filter_WidgetType["SORT"] = "SORT";
    reverb_search_Filter_WidgetType["REGION_SELECT"] = "REGION_SELECT";
})(reverb_search_Filter_WidgetType = exports.reverb_search_Filter_WidgetType || (exports.reverb_search_Filter_WidgetType = {}));
var core_apimessages_NegotiationState;
(function (core_apimessages_NegotiationState) {
    core_apimessages_NegotiationState["ACTIVE"] = "ACTIVE";
    core_apimessages_NegotiationState["ACCEPTED"] = "ACCEPTED";
    core_apimessages_NegotiationState["REJECTED"] = "REJECTED";
    core_apimessages_NegotiationState["EXPIRED"] = "EXPIRED";
})(core_apimessages_NegotiationState = exports.core_apimessages_NegotiationState || (exports.core_apimessages_NegotiationState = {}));
var core_apimessages_NegotiationParty;
(function (core_apimessages_NegotiationParty) {
    core_apimessages_NegotiationParty["BUYER"] = "BUYER";
    core_apimessages_NegotiationParty["SELLER"] = "SELLER";
})(core_apimessages_NegotiationParty = exports.core_apimessages_NegotiationParty || (exports.core_apimessages_NegotiationParty = {}));
var core_apimessages_Offer_OfferStatus;
(function (core_apimessages_Offer_OfferStatus) {
    core_apimessages_Offer_OfferStatus["ACTIVE"] = "ACTIVE";
    core_apimessages_Offer_OfferStatus["COUNTERED"] = "COUNTERED";
    core_apimessages_Offer_OfferStatus["ACCEPTED"] = "ACCEPTED";
    core_apimessages_Offer_OfferStatus["REJECTED"] = "REJECTED";
    core_apimessages_Offer_OfferStatus["EXPIRED"] = "EXPIRED";
})(core_apimessages_Offer_OfferStatus = exports.core_apimessages_Offer_OfferStatus || (exports.core_apimessages_Offer_OfferStatus = {}));
var core_apimessages_NegotiationType;
(function (core_apimessages_NegotiationType) {
    core_apimessages_NegotiationType["STANDARD"] = "STANDARD";
    core_apimessages_NegotiationType["AUTO_PUSH_OFFER"] = "AUTO_PUSH_OFFER";
    core_apimessages_NegotiationType["EMAIL"] = "EMAIL";
})(core_apimessages_NegotiationType = exports.core_apimessages_NegotiationType || (exports.core_apimessages_NegotiationType = {}));
var reverb_search_SuggestOptionScope_Type;
(function (reverb_search_SuggestOptionScope_Type) {
    reverb_search_SuggestOptionScope_Type["NONE"] = "NONE";
    reverb_search_SuggestOptionScope_Type["PRODUCT_TYPE"] = "PRODUCT_TYPE";
})(reverb_search_SuggestOptionScope_Type = exports.reverb_search_SuggestOptionScope_Type || (exports.reverb_search_SuggestOptionScope_Type = {}));
var reverb_search_CompletionType;
(function (reverb_search_CompletionType) {
    reverb_search_CompletionType["ALL"] = "ALL";
    reverb_search_CompletionType["CSP"] = "CSP";
    reverb_search_CompletionType["BRAND"] = "BRAND";
    reverb_search_CompletionType["BRAND_MODEL"] = "BRAND_MODEL";
    reverb_search_CompletionType["FREE_TEXT"] = "FREE_TEXT";
    reverb_search_CompletionType["PRODUCT_TYPE"] = "PRODUCT_TYPE";
    reverb_search_CompletionType["SUB_CATEGORY"] = "SUB_CATEGORY";
    reverb_search_CompletionType["SHOP"] = "SHOP";
})(reverb_search_CompletionType = exports.reverb_search_CompletionType || (exports.reverb_search_CompletionType = {}));
var reverb_search_PriceGuidesSearchRequest_Aggregation;
(function (reverb_search_PriceGuidesSearchRequest_Aggregation) {
    reverb_search_PriceGuidesSearchRequest_Aggregation["BRAND_NAMES"] = "BRAND_NAMES";
    reverb_search_PriceGuidesSearchRequest_Aggregation["CATEGORY_UUIDS"] = "CATEGORY_UUIDS";
    reverb_search_PriceGuidesSearchRequest_Aggregation["DECADES"] = "DECADES";
})(reverb_search_PriceGuidesSearchRequest_Aggregation = exports.reverb_search_PriceGuidesSearchRequest_Aggregation || (exports.reverb_search_PriceGuidesSearchRequest_Aggregation = {}));
var reverb_search_LPReleasesSearchRequest_Aggregation;
(function (reverb_search_LPReleasesSearchRequest_Aggregation) {
    reverb_search_LPReleasesSearchRequest_Aggregation["COUNTRIES"] = "COUNTRIES";
    reverb_search_LPReleasesSearchRequest_Aggregation["FORMATS"] = "FORMATS";
    reverb_search_LPReleasesSearchRequest_Aggregation["INVENTORY"] = "INVENTORY";
})(reverb_search_LPReleasesSearchRequest_Aggregation = exports.reverb_search_LPReleasesSearchRequest_Aggregation || (exports.reverb_search_LPReleasesSearchRequest_Aggregation = {}));
var core_apimessages_CollectionHeader_CollectionType;
(function (core_apimessages_CollectionHeader_CollectionType) {
    core_apimessages_CollectionHeader_CollectionType["Category"] = "Category";
    core_apimessages_CollectionHeader_CollectionType["Brand"] = "Brand";
    core_apimessages_CollectionHeader_CollectionType["CuratedSearch"] = "CuratedSearch";
    core_apimessages_CollectionHeader_CollectionType["CuratedSet"] = "CuratedSet";
    core_apimessages_CollectionHeader_CollectionType["ProductType"] = "ProductType";
})(core_apimessages_CollectionHeader_CollectionType = exports.core_apimessages_CollectionHeader_CollectionType || (exports.core_apimessages_CollectionHeader_CollectionType = {}));
var core_apimessages_MyShopOnboardingResponse_BillingMethodStatus;
(function (core_apimessages_MyShopOnboardingResponse_BillingMethodStatus) {
    core_apimessages_MyShopOnboardingResponse_BillingMethodStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
    core_apimessages_MyShopOnboardingResponse_BillingMethodStatus["REQUIRED"] = "REQUIRED";
    core_apimessages_MyShopOnboardingResponse_BillingMethodStatus["COMPLETED"] = "COMPLETED";
})(core_apimessages_MyShopOnboardingResponse_BillingMethodStatus = exports.core_apimessages_MyShopOnboardingResponse_BillingMethodStatus || (exports.core_apimessages_MyShopOnboardingResponse_BillingMethodStatus = {}));
var core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus;
(function (core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus) {
    core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus["PAYPAL_NOT_COMPLETED"] = "PAYPAL_NOT_COMPLETED";
    core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus["PAYPAL_COMPLETED"] = "PAYPAL_COMPLETED";
})(core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus = exports.core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus || (exports.core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus = {}));
var core_apimessages_MyShopOnboardingResponse_PaymentMethod;
(function (core_apimessages_MyShopOnboardingResponse_PaymentMethod) {
    core_apimessages_MyShopOnboardingResponse_PaymentMethod["NOT_SETUP"] = "NOT_SETUP";
    core_apimessages_MyShopOnboardingResponse_PaymentMethod["REVERB_PAYMENTS"] = "REVERB_PAYMENTS";
    core_apimessages_MyShopOnboardingResponse_PaymentMethod["PAYPAL"] = "PAYPAL";
})(core_apimessages_MyShopOnboardingResponse_PaymentMethod = exports.core_apimessages_MyShopOnboardingResponse_PaymentMethod || (exports.core_apimessages_MyShopOnboardingResponse_PaymentMethod = {}));
var core_apimessages_FeePaymentMethod;
(function (core_apimessages_FeePaymentMethod) {
    core_apimessages_FeePaymentMethod["PAYOUT_DEDUCTION"] = "PAYOUT_DEDUCTION";
    core_apimessages_FeePaymentMethod["STATEMENT_BILLING"] = "STATEMENT_BILLING";
})(core_apimessages_FeePaymentMethod = exports.core_apimessages_FeePaymentMethod || (exports.core_apimessages_FeePaymentMethod = {}));
var rql_FollowsQuery_Channel;
(function (rql_FollowsQuery_Channel) {
    rql_FollowsQuery_Channel["REVERB"] = "REVERB";
    rql_FollowsQuery_Channel["LP"] = "LP";
})(rql_FollowsQuery_Channel = exports.rql_FollowsQuery_Channel || (exports.rql_FollowsQuery_Channel = {}));
var reverb_feed_SearchableType;
(function (reverb_feed_SearchableType) {
    reverb_feed_SearchableType["FILTERED_QUERY"] = "FILTERED_QUERY";
    reverb_feed_SearchableType["COMPARISON_SHOPPING_PAGE"] = "COMPARISON_SHOPPING_PAGE";
    reverb_feed_SearchableType["CURATED_SET"] = "CURATED_SET";
    reverb_feed_SearchableType["SHOP"] = "SHOP";
    reverb_feed_SearchableType["BRAND"] = "BRAND";
    reverb_feed_SearchableType["CATEGORY"] = "CATEGORY";
    reverb_feed_SearchableType["PRODUCT_TYPE"] = "PRODUCT_TYPE";
    reverb_feed_SearchableType["CURATED_SEARCH"] = "CURATED_SEARCH";
    reverb_feed_SearchableType["PROFILE"] = "PROFILE";
    reverb_feed_SearchableType["ALBUM"] = "ALBUM";
    reverb_feed_SearchableType["RELEASE"] = "RELEASE";
    reverb_feed_SearchableType["LABEL"] = "LABEL";
    reverb_feed_SearchableType["ARTIST"] = "ARTIST";
})(reverb_feed_SearchableType = exports.reverb_feed_SearchableType || (exports.reverb_feed_SearchableType = {}));
var rql_FeedQuery_Channel;
(function (rql_FeedQuery_Channel) {
    rql_FeedQuery_Channel["REVERB"] = "REVERB";
    rql_FeedQuery_Channel["LP"] = "LP";
})(rql_FeedQuery_Channel = exports.rql_FeedQuery_Channel || (exports.rql_FeedQuery_Channel = {}));
var reverb_feed_FeedEntry_EntryType;
(function (reverb_feed_FeedEntry_EntryType) {
    reverb_feed_FeedEntry_EntryType["LISTING"] = "LISTING";
    reverb_feed_FeedEntry_EntryType["CSP"] = "CSP";
    reverb_feed_FeedEntry_EntryType["ARTICLE"] = "ARTICLE";
    reverb_feed_FeedEntry_EntryType["SHOP"] = "SHOP";
    reverb_feed_FeedEntry_EntryType["FILTERED_QUERY"] = "FILTERED_QUERY";
    reverb_feed_FeedEntry_EntryType["PROFILE"] = "PROFILE";
    reverb_feed_FeedEntry_EntryType["ALBUM"] = "ALBUM";
    reverb_feed_FeedEntry_EntryType["RELEASE"] = "RELEASE";
    reverb_feed_FeedEntry_EntryType["PAGE"] = "PAGE";
    reverb_feed_FeedEntry_EntryType["LABEL"] = "LABEL";
    reverb_feed_FeedEntry_EntryType["ARTIST"] = "ARTIST";
    reverb_feed_FeedEntry_EntryType["REMOVE"] = "REMOVE";
})(reverb_feed_FeedEntry_EntryType = exports.reverb_feed_FeedEntry_EntryType || (exports.reverb_feed_FeedEntry_EntryType = {}));
var reverb_feed_FeedSourceType;
(function (reverb_feed_FeedSourceType) {
    reverb_feed_FeedSourceType["NONE"] = "NONE";
    reverb_feed_FeedSourceType["SAVED_SEARCH"] = "SAVED_SEARCH";
    reverb_feed_FeedSourceType["WATCH"] = "WATCH";
})(reverb_feed_FeedSourceType = exports.reverb_feed_FeedSourceType || (exports.reverb_feed_FeedSourceType = {}));
var personalizer_EntityType;
(function (personalizer_EntityType) {
    personalizer_EntityType["ARTICLE"] = "ARTICLE";
    personalizer_EntityType["CANONICAL_PRODUCT"] = "CANONICAL_PRODUCT";
    personalizer_EntityType["COMPARISON_SHOPPING_PAGE"] = "COMPARISON_SHOPPING_PAGE";
    personalizer_EntityType["PRODUCT"] = "PRODUCT";
})(personalizer_EntityType = exports.personalizer_EntityType || (exports.personalizer_EntityType = {}));
var rql_NegotiationQuery_Party;
(function (rql_NegotiationQuery_Party) {
    rql_NegotiationQuery_Party["BUYER"] = "BUYER";
    rql_NegotiationQuery_Party["SELLER"] = "SELLER";
})(rql_NegotiationQuery_Party = exports.rql_NegotiationQuery_Party || (exports.rql_NegotiationQuery_Party = {}));
var rql_NegotiationQuery_State;
(function (rql_NegotiationQuery_State) {
    rql_NegotiationQuery_State["ACTIVE"] = "ACTIVE";
    rql_NegotiationQuery_State["ACCEPTED"] = "ACCEPTED";
    rql_NegotiationQuery_State["REJECTED"] = "REJECTED";
    rql_NegotiationQuery_State["EXPIRED"] = "EXPIRED";
})(rql_NegotiationQuery_State = exports.rql_NegotiationQuery_State || (exports.rql_NegotiationQuery_State = {}));
var reverb_search_AuctionsSearchRequest_Aggregation;
(function (reverb_search_AuctionsSearchRequest_Aggregation) {
    reverb_search_AuctionsSearchRequest_Aggregation["USER_BID_STATUS"] = "USER_BID_STATUS";
})(reverb_search_AuctionsSearchRequest_Aggregation = exports.reverb_search_AuctionsSearchRequest_Aggregation || (exports.reverb_search_AuctionsSearchRequest_Aggregation = {}));
var reverb_search_AuctionsSearchRequest_UserBidStatus;
(function (reverb_search_AuctionsSearchRequest_UserBidStatus) {
    reverb_search_AuctionsSearchRequest_UserBidStatus["ACTIVE"] = "ACTIVE";
    reverb_search_AuctionsSearchRequest_UserBidStatus["ALL"] = "ALL";
    reverb_search_AuctionsSearchRequest_UserBidStatus["WON"] = "WON";
    reverb_search_AuctionsSearchRequest_UserBidStatus["LOST"] = "LOST";
})(reverb_search_AuctionsSearchRequest_UserBidStatus = exports.reverb_search_AuctionsSearchRequest_UserBidStatus || (exports.reverb_search_AuctionsSearchRequest_UserBidStatus = {}));
var reverb_search_AuctionsSearchRequest_MerchandisingType;
(function (reverb_search_AuctionsSearchRequest_MerchandisingType) {
    reverb_search_AuctionsSearchRequest_MerchandisingType["LP"] = "LP";
    reverb_search_AuctionsSearchRequest_MerchandisingType["DIGITAL"] = "DIGITAL";
})(reverb_search_AuctionsSearchRequest_MerchandisingType = exports.reverb_search_AuctionsSearchRequest_MerchandisingType || (exports.reverb_search_AuctionsSearchRequest_MerchandisingType = {}));
var core_apimessages_WatchesRequest_ListingState;
(function (core_apimessages_WatchesRequest_ListingState) {
    core_apimessages_WatchesRequest_ListingState["ALL"] = "ALL";
    core_apimessages_WatchesRequest_ListingState["LIVE"] = "LIVE";
    core_apimessages_WatchesRequest_ListingState["NOT_LIVE"] = "NOT_LIVE";
})(core_apimessages_WatchesRequest_ListingState = exports.core_apimessages_WatchesRequest_ListingState || (exports.core_apimessages_WatchesRequest_ListingState = {}));
var cms_ComponentRelationType;
(function (cms_ComponentRelationType) {
    cms_ComponentRelationType["ALBUM"] = "ALBUM";
    cms_ComponentRelationType["ARTIST"] = "ARTIST";
})(cms_ComponentRelationType = exports.cms_ComponentRelationType || (exports.cms_ComponentRelationType = {}));
var core_apimessages_AdyenLegalEntity;
(function (core_apimessages_AdyenLegalEntity) {
    core_apimessages_AdyenLegalEntity["INDIVIDUAL"] = "INDIVIDUAL";
    core_apimessages_AdyenLegalEntity["BUSINESS"] = "BUSINESS";
})(core_apimessages_AdyenLegalEntity = exports.core_apimessages_AdyenLegalEntity || (exports.core_apimessages_AdyenLegalEntity = {}));
var core_apimessages_AdyenPaymentResult_PaymentStatus;
(function (core_apimessages_AdyenPaymentResult_PaymentStatus) {
    core_apimessages_AdyenPaymentResult_PaymentStatus["SUCCESS"] = "SUCCESS";
    core_apimessages_AdyenPaymentResult_PaymentStatus["IDENTIFY_SHOPPER_REQUIRED"] = "IDENTIFY_SHOPPER_REQUIRED";
    core_apimessages_AdyenPaymentResult_PaymentStatus["CHALLENGE_SHOPPER_REQUIRED"] = "CHALLENGE_SHOPPER_REQUIRED";
    core_apimessages_AdyenPaymentResult_PaymentStatus["FAILED"] = "FAILED";
    core_apimessages_AdyenPaymentResult_PaymentStatus["REDIRECT_SHOPPER_REQUIRED"] = "REDIRECT_SHOPPER_REQUIRED";
})(core_apimessages_AdyenPaymentResult_PaymentStatus = exports.core_apimessages_AdyenPaymentResult_PaymentStatus || (exports.core_apimessages_AdyenPaymentResult_PaymentStatus = {}));
var core_apimessages_NegotiationAction;
(function (core_apimessages_NegotiationAction) {
    core_apimessages_NegotiationAction["CREATE"] = "CREATE";
    core_apimessages_NegotiationAction["ACCEPT"] = "ACCEPT";
    core_apimessages_NegotiationAction["REJECT"] = "REJECT";
    core_apimessages_NegotiationAction["COUNTER"] = "COUNTER";
})(core_apimessages_NegotiationAction = exports.core_apimessages_NegotiationAction || (exports.core_apimessages_NegotiationAction = {}));
var core_apimessages_ShippingProtectionStatus;
(function (core_apimessages_ShippingProtectionStatus) {
    core_apimessages_ShippingProtectionStatus["PROTECTION_OPTIONAL"] = "PROTECTION_OPTIONAL";
    core_apimessages_ShippingProtectionStatus["PROTECTION_REQUIRED"] = "PROTECTION_REQUIRED";
    core_apimessages_ShippingProtectionStatus["PROTECTION_NOT_SUPPORTED"] = "PROTECTION_NOT_SUPPORTED";
})(core_apimessages_ShippingProtectionStatus = exports.core_apimessages_ShippingProtectionStatus || (exports.core_apimessages_ShippingProtectionStatus = {}));
var core_apimessages_SignatureRequiredStatus;
(function (core_apimessages_SignatureRequiredStatus) {
    core_apimessages_SignatureRequiredStatus["SIGNATURE_OPTIONAL"] = "SIGNATURE_OPTIONAL";
    core_apimessages_SignatureRequiredStatus["SIGNATURE_REQUIRED"] = "SIGNATURE_REQUIRED";
    core_apimessages_SignatureRequiredStatus["SIGNATURE_NOT_SUPPORTED"] = "SIGNATURE_NOT_SUPPORTED";
    core_apimessages_SignatureRequiredStatus["SIGNATURE_REQUIRED_WITH_INSURANCE"] = "SIGNATURE_REQUIRED_WITH_INSURANCE";
})(core_apimessages_SignatureRequiredStatus = exports.core_apimessages_SignatureRequiredStatus || (exports.core_apimessages_SignatureRequiredStatus = {}));
var core_apimessages_MyAddressType;
(function (core_apimessages_MyAddressType) {
    core_apimessages_MyAddressType["SHIPPING"] = "SHIPPING";
    core_apimessages_MyAddressType["SHOP"] = "SHOP";
    core_apimessages_MyAddressType["EU_ODR_PLATFORM"] = "EU_ODR_PLATFORM";
})(core_apimessages_MyAddressType = exports.core_apimessages_MyAddressType || (exports.core_apimessages_MyAddressType = {}));
var core_apimessages_CuratedSet_SetType;
(function (core_apimessages_CuratedSet_SetType) {
    core_apimessages_CuratedSet_SetType["NONE"] = "NONE";
    core_apimessages_CuratedSet_SetType["LP_SELLER_PICKS"] = "LP_SELLER_PICKS";
})(core_apimessages_CuratedSet_SetType = exports.core_apimessages_CuratedSet_SetType || (exports.core_apimessages_CuratedSet_SetType = {}));
var google_protobuf_FieldDescriptorProto_Label;
(function (google_protobuf_FieldDescriptorProto_Label) {
    google_protobuf_FieldDescriptorProto_Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    google_protobuf_FieldDescriptorProto_Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    google_protobuf_FieldDescriptorProto_Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(google_protobuf_FieldDescriptorProto_Label = exports.google_protobuf_FieldDescriptorProto_Label || (exports.google_protobuf_FieldDescriptorProto_Label = {}));
var google_protobuf_FieldDescriptorProto_Type;
(function (google_protobuf_FieldDescriptorProto_Type) {
    google_protobuf_FieldDescriptorProto_Type["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    google_protobuf_FieldDescriptorProto_Type["TYPE_FLOAT"] = "TYPE_FLOAT";
    google_protobuf_FieldDescriptorProto_Type["TYPE_INT64"] = "TYPE_INT64";
    google_protobuf_FieldDescriptorProto_Type["TYPE_UINT64"] = "TYPE_UINT64";
    google_protobuf_FieldDescriptorProto_Type["TYPE_INT32"] = "TYPE_INT32";
    google_protobuf_FieldDescriptorProto_Type["TYPE_FIXED64"] = "TYPE_FIXED64";
    google_protobuf_FieldDescriptorProto_Type["TYPE_FIXED32"] = "TYPE_FIXED32";
    google_protobuf_FieldDescriptorProto_Type["TYPE_BOOL"] = "TYPE_BOOL";
    google_protobuf_FieldDescriptorProto_Type["TYPE_STRING"] = "TYPE_STRING";
    google_protobuf_FieldDescriptorProto_Type["TYPE_GROUP"] = "TYPE_GROUP";
    google_protobuf_FieldDescriptorProto_Type["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    google_protobuf_FieldDescriptorProto_Type["TYPE_BYTES"] = "TYPE_BYTES";
    google_protobuf_FieldDescriptorProto_Type["TYPE_UINT32"] = "TYPE_UINT32";
    google_protobuf_FieldDescriptorProto_Type["TYPE_ENUM"] = "TYPE_ENUM";
    google_protobuf_FieldDescriptorProto_Type["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    google_protobuf_FieldDescriptorProto_Type["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    google_protobuf_FieldDescriptorProto_Type["TYPE_SINT32"] = "TYPE_SINT32";
    google_protobuf_FieldDescriptorProto_Type["TYPE_SINT64"] = "TYPE_SINT64";
})(google_protobuf_FieldDescriptorProto_Type = exports.google_protobuf_FieldDescriptorProto_Type || (exports.google_protobuf_FieldDescriptorProto_Type = {}));
var google_protobuf_FieldOptions_CType;
(function (google_protobuf_FieldOptions_CType) {
    google_protobuf_FieldOptions_CType["STRING"] = "STRING";
    google_protobuf_FieldOptions_CType["CORD"] = "CORD";
    google_protobuf_FieldOptions_CType["STRING_PIECE"] = "STRING_PIECE";
})(google_protobuf_FieldOptions_CType = exports.google_protobuf_FieldOptions_CType || (exports.google_protobuf_FieldOptions_CType = {}));
var google_protobuf_FieldOptions_JSType;
(function (google_protobuf_FieldOptions_JSType) {
    google_protobuf_FieldOptions_JSType["JS_NORMAL"] = "JS_NORMAL";
    google_protobuf_FieldOptions_JSType["JS_STRING"] = "JS_STRING";
    google_protobuf_FieldOptions_JSType["JS_NUMBER"] = "JS_NUMBER";
})(google_protobuf_FieldOptions_JSType = exports.google_protobuf_FieldOptions_JSType || (exports.google_protobuf_FieldOptions_JSType = {}));
var google_protobuf_MethodOptions_IdempotencyLevel;
(function (google_protobuf_MethodOptions_IdempotencyLevel) {
    google_protobuf_MethodOptions_IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    google_protobuf_MethodOptions_IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    google_protobuf_MethodOptions_IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(google_protobuf_MethodOptions_IdempotencyLevel = exports.google_protobuf_MethodOptions_IdempotencyLevel || (exports.google_protobuf_MethodOptions_IdempotencyLevel = {}));
var google_protobuf_FileOptions_OptimizeMode;
(function (google_protobuf_FileOptions_OptimizeMode) {
    google_protobuf_FileOptions_OptimizeMode["SPEED"] = "SPEED";
    google_protobuf_FileOptions_OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    google_protobuf_FileOptions_OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(google_protobuf_FileOptions_OptimizeMode = exports.google_protobuf_FileOptions_OptimizeMode || (exports.google_protobuf_FileOptions_OptimizeMode = {}));
var reverb_feed_FeedEntryUpdated_Action;
(function (reverb_feed_FeedEntryUpdated_Action) {
    reverb_feed_FeedEntryUpdated_Action["ADD"] = "ADD";
    reverb_feed_FeedEntryUpdated_Action["REMOVE"] = "REMOVE";
    reverb_feed_FeedEntryUpdated_Action["REMOVE_ALL"] = "REMOVE_ALL";
    reverb_feed_FeedEntryUpdated_Action["REMOVE_BY_SOURCE"] = "REMOVE_BY_SOURCE";
    reverb_feed_FeedEntryUpdated_Action["ADD_BY_SOURCE"] = "ADD_BY_SOURCE";
    reverb_feed_FeedEntryUpdated_Action["REMOVE_DIGEST"] = "REMOVE_DIGEST";
})(reverb_feed_FeedEntryUpdated_Action = exports.reverb_feed_FeedEntryUpdated_Action || (exports.reverb_feed_FeedEntryUpdated_Action = {}));
var reverb_feed_FollowsTopic_Action;
(function (reverb_feed_FollowsTopic_Action) {
    reverb_feed_FollowsTopic_Action["REMOVE"] = "REMOVE";
    reverb_feed_FollowsTopic_Action["REMOVE_BY_SEARCHABLE"] = "REMOVE_BY_SEARCHABLE";
})(reverb_feed_FollowsTopic_Action = exports.reverb_feed_FollowsTopic_Action || (exports.reverb_feed_FollowsTopic_Action = {}));
var cms_RelationType;
(function (cms_RelationType) {
    cms_RelationType["MasterManifest"] = "MasterManifest";
    cms_RelationType["ArtistManifest"] = "ArtistManifest";
})(cms_RelationType = exports.cms_RelationType || (exports.cms_RelationType = {}));
var core_apimessages_KYCAction;
(function (core_apimessages_KYCAction) {
    core_apimessages_KYCAction["NONE"] = "NONE";
    core_apimessages_KYCAction["UPLOAD_DOCUMENT"] = "UPLOAD_DOCUMENT";
    core_apimessages_KYCAction["UPDATE_INFORMATION"] = "UPDATE_INFORMATION";
})(core_apimessages_KYCAction = exports.core_apimessages_KYCAction || (exports.core_apimessages_KYCAction = {}));
var core_apimessages_KYCPhotoIDType;
(function (core_apimessages_KYCPhotoIDType) {
    core_apimessages_KYCPhotoIDType["PASSPORT"] = "PASSPORT";
    core_apimessages_KYCPhotoIDType["ID_CARD"] = "ID_CARD";
    core_apimessages_KYCPhotoIDType["DRIVING_LICENSE"] = "DRIVING_LICENSE";
})(core_apimessages_KYCPhotoIDType = exports.core_apimessages_KYCPhotoIDType || (exports.core_apimessages_KYCPhotoIDType = {}));
var core_apimessages_CreateShipmentErrorType;
(function (core_apimessages_CreateShipmentErrorType) {
    core_apimessages_CreateShipmentErrorType["SHIPMENT_FORM_BASE_ERROR"] = "SHIPMENT_FORM_BASE_ERROR";
    core_apimessages_CreateShipmentErrorType["SHIPMENT_FORM_CUSTOMS_ERROR"] = "SHIPMENT_FORM_CUSTOMS_ERROR";
    core_apimessages_CreateShipmentErrorType["SHIPMENT_FORM_CUSTOMS_SIGNER_ERROR"] = "SHIPMENT_FORM_CUSTOMS_SIGNER_ERROR";
})(core_apimessages_CreateShipmentErrorType = exports.core_apimessages_CreateShipmentErrorType || (exports.core_apimessages_CreateShipmentErrorType = {}));
var core_apimessages_TraitsRequest_TraitableType;
(function (core_apimessages_TraitsRequest_TraitableType) {
    core_apimessages_TraitsRequest_TraitableType["Product"] = "Product";
})(core_apimessages_TraitsRequest_TraitableType = exports.core_apimessages_TraitsRequest_TraitableType || (exports.core_apimessages_TraitsRequest_TraitableType = {}));
var core_apimessages_CategoryRequest_CategoryType;
(function (core_apimessages_CategoryRequest_CategoryType) {
    core_apimessages_CategoryRequest_CategoryType["CATEGORY"] = "CATEGORY";
    core_apimessages_CategoryRequest_CategoryType["ARTICLE"] = "ARTICLE";
})(core_apimessages_CategoryRequest_CategoryType = exports.core_apimessages_CategoryRequest_CategoryType || (exports.core_apimessages_CategoryRequest_CategoryType = {}));
var core_apimessages_VideosRequest_VideolinkableType;
(function (core_apimessages_VideosRequest_VideolinkableType) {
    core_apimessages_VideosRequest_VideolinkableType["PRODUCT"] = "PRODUCT";
    core_apimessages_VideosRequest_VideolinkableType["SHOP"] = "SHOP";
})(core_apimessages_VideosRequest_VideolinkableType = exports.core_apimessages_VideosRequest_VideolinkableType || (exports.core_apimessages_VideosRequest_VideolinkableType = {}));
var core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType;
(function (core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType) {
    core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType["PRODUCT"] = "PRODUCT";
    core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType["SHOP"] = "SHOP";
})(core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType = exports.core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType || (exports.core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType = {}));
var core_apimessages_PrimaryKey_Type;
(function (core_apimessages_PrimaryKey_Type) {
    core_apimessages_PrimaryKey_Type["UNKNOWN"] = "UNKNOWN";
    core_apimessages_PrimaryKey_Type["ID"] = "ID";
    core_apimessages_PrimaryKey_Type["UUID"] = "UUID";
    core_apimessages_PrimaryKey_Type["SLUG"] = "SLUG";
})(core_apimessages_PrimaryKey_Type = exports.core_apimessages_PrimaryKey_Type || (exports.core_apimessages_PrimaryKey_Type = {}));
var core_apimessages_BulkAddressesRequest_Relation;
(function (core_apimessages_BulkAddressesRequest_Relation) {
    core_apimessages_BulkAddressesRequest_Relation["UNKNOWN"] = "UNKNOWN";
    core_apimessages_BulkAddressesRequest_Relation["MY_SHIPPING"] = "MY_SHIPPING";
    core_apimessages_BulkAddressesRequest_Relation["MY_SHOP"] = "MY_SHOP";
    core_apimessages_BulkAddressesRequest_Relation["ORDER_SHIPPING"] = "ORDER_SHIPPING";
    core_apimessages_BulkAddressesRequest_Relation["ORDER_BUNDLE_SHIPPING"] = "ORDER_BUNDLE_SHIPPING";
    core_apimessages_BulkAddressesRequest_Relation["EU_ODR_PLATFORM"] = "EU_ODR_PLATFORM";
})(core_apimessages_BulkAddressesRequest_Relation = exports.core_apimessages_BulkAddressesRequest_Relation || (exports.core_apimessages_BulkAddressesRequest_Relation = {}));
var core_apimessages_BulkOrderBundlesRequest_Relation;
(function (core_apimessages_BulkOrderBundlesRequest_Relation) {
    core_apimessages_BulkOrderBundlesRequest_Relation["UNKNOWN"] = "UNKNOWN";
    core_apimessages_BulkOrderBundlesRequest_Relation["SELF"] = "SELF";
})(core_apimessages_BulkOrderBundlesRequest_Relation = exports.core_apimessages_BulkOrderBundlesRequest_Relation || (exports.core_apimessages_BulkOrderBundlesRequest_Relation = {}));
var core_apimessages_BulkOrdersRequest_Relation;
(function (core_apimessages_BulkOrdersRequest_Relation) {
    core_apimessages_BulkOrdersRequest_Relation["UNKNOWN"] = "UNKNOWN";
    core_apimessages_BulkOrdersRequest_Relation["SELF"] = "SELF";
    core_apimessages_BulkOrdersRequest_Relation["ORDER_BUNDLE"] = "ORDER_BUNDLE";
    core_apimessages_BulkOrdersRequest_Relation["LISTING"] = "LISTING";
})(core_apimessages_BulkOrdersRequest_Relation = exports.core_apimessages_BulkOrdersRequest_Relation || (exports.core_apimessages_BulkOrdersRequest_Relation = {}));
var core_apimessages_BulkCuratedSetsRequest_Relation;
(function (core_apimessages_BulkCuratedSetsRequest_Relation) {
    core_apimessages_BulkCuratedSetsRequest_Relation["SELF"] = "SELF";
    core_apimessages_BulkCuratedSetsRequest_Relation["STOREFRONT"] = "STOREFRONT";
})(core_apimessages_BulkCuratedSetsRequest_Relation = exports.core_apimessages_BulkCuratedSetsRequest_Relation || (exports.core_apimessages_BulkCuratedSetsRequest_Relation = {}));
var core_apimessages_PriceGuideRequest_PriceGuideRelation;
(function (core_apimessages_PriceGuideRequest_PriceGuideRelation) {
    core_apimessages_PriceGuideRequest_PriceGuideRelation["SELF"] = "SELF";
    core_apimessages_PriceGuideRequest_PriceGuideRelation["CSP"] = "CSP";
})(core_apimessages_PriceGuideRequest_PriceGuideRelation = exports.core_apimessages_PriceGuideRequest_PriceGuideRelation || (exports.core_apimessages_PriceGuideRequest_PriceGuideRelation = {}));
var reverb_search_NegotiationSearchRequest_Aggregation;
(function (reverb_search_NegotiationSearchRequest_Aggregation) {
    reverb_search_NegotiationSearchRequest_Aggregation["STATES"] = "STATES";
    reverb_search_NegotiationSearchRequest_Aggregation["CHANNELS"] = "CHANNELS";
    reverb_search_NegotiationSearchRequest_Aggregation["SELLER_CHANNELS"] = "SELLER_CHANNELS";
    reverb_search_NegotiationSearchRequest_Aggregation["ACTIVE_SELLER_ACTION_REQUIRED"] = "ACTIVE_SELLER_ACTION_REQUIRED";
    reverb_search_NegotiationSearchRequest_Aggregation["NEGOTIATION_TYPES"] = "NEGOTIATION_TYPES";
    reverb_search_NegotiationSearchRequest_Aggregation["LISTING_NEGOTIATION_METRICS"] = "LISTING_NEGOTIATION_METRICS";
})(reverb_search_NegotiationSearchRequest_Aggregation = exports.reverb_search_NegotiationSearchRequest_Aggregation || (exports.reverb_search_NegotiationSearchRequest_Aggregation = {}));
var reverb_search_NegotiationSearchRequest_State;
(function (reverb_search_NegotiationSearchRequest_State) {
    reverb_search_NegotiationSearchRequest_State["ACTIVE"] = "ACTIVE";
    reverb_search_NegotiationSearchRequest_State["ACCEPTED"] = "ACCEPTED";
    reverb_search_NegotiationSearchRequest_State["REJECTED"] = "REJECTED";
    reverb_search_NegotiationSearchRequest_State["EXPIRED"] = "EXPIRED";
})(reverb_search_NegotiationSearchRequest_State = exports.reverb_search_NegotiationSearchRequest_State || (exports.reverb_search_NegotiationSearchRequest_State = {}));
var reverb_search_NegotiationSearchRequest_Type;
(function (reverb_search_NegotiationSearchRequest_Type) {
    reverb_search_NegotiationSearchRequest_Type["AUTO_PUSH_OFFER"] = "AUTO_PUSH_OFFER";
    reverb_search_NegotiationSearchRequest_Type["EMAIL"] = "EMAIL";
    reverb_search_NegotiationSearchRequest_Type["STANDARD"] = "STANDARD";
})(reverb_search_NegotiationSearchRequest_Type = exports.reverb_search_NegotiationSearchRequest_Type || (exports.reverb_search_NegotiationSearchRequest_Type = {}));
var reverb_search_LPTransactionsSearchRequest_ActionableStatus;
(function (reverb_search_LPTransactionsSearchRequest_ActionableStatus) {
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["AWAITING_PICKUP"] = "AWAITING_PICKUP";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["AWAITING_SHIPMENT"] = "AWAITING_SHIPMENT";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["CANCELLED"] = "CANCELLED";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["LAYAWAY"] = "LAYAWAY";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["LAYAWAY_FORFEITED"] = "LAYAWAY_FORFEITED";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["PICKED_UP"] = "PICKED_UP";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["PREORDER"] = "PREORDER";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["RECEIVED"] = "RECEIVED";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["REFUNDED"] = "REFUNDED";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["REFUND_APPROVED"] = "REFUND_APPROVED";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["REFUND_REQUESTED"] = "REFUND_REQUESTED";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["SHIPPED"] = "SHIPPED";
    reverb_search_LPTransactionsSearchRequest_ActionableStatus["UNPAID"] = "UNPAID";
})(reverb_search_LPTransactionsSearchRequest_ActionableStatus = exports.reverb_search_LPTransactionsSearchRequest_ActionableStatus || (exports.reverb_search_LPTransactionsSearchRequest_ActionableStatus = {}));
var reverb_search_LPTransactionsSearchRequest_Aggregation;
(function (reverb_search_LPTransactionsSearchRequest_Aggregation) {
    reverb_search_LPTransactionsSearchRequest_Aggregation["ACTIONABLE_STATUSES"] = "ACTIONABLE_STATUSES";
    reverb_search_LPTransactionsSearchRequest_Aggregation["PRICE_PERCENTILES"] = "PRICE_PERCENTILES";
    reverb_search_LPTransactionsSearchRequest_Aggregation["PRICE_PERCENTILES_BY_MEDIA_CONDITION"] = "PRICE_PERCENTILES_BY_MEDIA_CONDITION";
})(reverb_search_LPTransactionsSearchRequest_Aggregation = exports.reverb_search_LPTransactionsSearchRequest_Aggregation || (exports.reverb_search_LPTransactionsSearchRequest_Aggregation = {}));
var reverb_reporting_TimeGrouping;
(function (reverb_reporting_TimeGrouping) {
    reverb_reporting_TimeGrouping["DAY"] = "DAY";
    reverb_reporting_TimeGrouping["MONTH"] = "MONTH";
})(reverb_reporting_TimeGrouping = exports.reverb_reporting_TimeGrouping || (exports.reverb_reporting_TimeGrouping = {}));
var lp_Ribbon_Reason;
(function (lp_Ribbon_Reason) {
    lp_Ribbon_Reason["PRICE_DROP"] = "PRICE_DROP";
    lp_Ribbon_Reason["SALE"] = "SALE";
})(lp_Ribbon_Reason = exports.lp_Ribbon_Reason || (exports.lp_Ribbon_Reason = {}));
var lp_APIArtistType;
(function (lp_APIArtistType) {
    lp_APIArtistType["RELEASE"] = "RELEASE";
    lp_APIArtistType["ALBUM"] = "ALBUM";
})(lp_APIArtistType = exports.lp_APIArtistType || (exports.lp_APIArtistType = {}));
var lp_APIImagesRequest_ImageType;
(function (lp_APIImagesRequest_ImageType) {
    lp_APIImagesRequest_ImageType["Release"] = "Release";
    lp_APIImagesRequest_ImageType["Album"] = "Album";
})(lp_APIImagesRequest_ImageType = exports.lp_APIImagesRequest_ImageType || (exports.lp_APIImagesRequest_ImageType = {}));
var ErrorMode;
(function (ErrorMode) {
    ErrorMode["RAISE_ALL"] = "RAISE_ALL";
    ErrorMode["IGNORE_ALL"] = "IGNORE_ALL";
})(ErrorMode = exports.ErrorMode || (exports.ErrorMode = {}));
//# sourceMappingURL=rql.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/schemas/rql.js
// module id = 4SQb
// module chunks = 20 21 22